import React, { createContext, useEffect, useState } from "react";
import { BUSINESS_CONFIG_URL } from "../config/config";
import PropTypes from "prop-types";
import _ from "lodash";
import ErrorBlock from "../uiwidgets/ErrorBlock";
import {API} from "../api/API";
import { extractError } from "api/ErrorUtil";
import EmptySidebarLayout from "uiwidgets/layouts/EmptySidebarLayout";
import AppSpinner from "uiwidgets/AppSpinner";

export const TenantContext = createContext();
const TenantContextProvider = props => {
  //const [stripePromise, setStripePromise] = useState({})
  const [businessConfig, setBusinessConfig] = useState({});
  const [apiError, setApiError] = useState({});
  const [businessConfigLoaded, setBusinessConfigLoaded] = useState(false);
  
  useEffect(() => {
    console.log("Running tenant use effect");
    API.get(`${BUSINESS_CONFIG_URL}`)
      .then(resp => {
        let data = _.get(resp, "data", {});
        sessionStorage.setItem("business_id", data.business_id);
        sessionStorage.setItem("paymentGatewayBusinessId",data.paymentGatewayBusinessId);
        sessionStorage.setItem("publishablekey",data.publishablekey);
        //change locale string
        data.locale = _.replace(data.locale,new RegExp("_","g"),"-");
        setBusinessConfig(data);
        setBusinessConfigLoaded(true);
      })
      .catch(error => {
        setApiError(extractError(error));
        setBusinessConfigLoaded(true);
      });

  }, []);

  if (!_.isEmpty(apiError)) {
    return <EmptySidebarLayout><ErrorBlock error={apiError} /></EmptySidebarLayout>;
  }

  if (!businessConfigLoaded) {
        console.log("Business config spinner");
        return <AppSpinner/>;
  }

  return (
    <>
    {businessConfigLoaded && <TenantContext.Provider value={{ businessConfig: businessConfig, /*stripePromise: stripePromise*/ }}>
      {props.children}
    </TenantContext.Provider>}
    </>);
};

TenantContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default TenantContextProvider;
